export default __webpack_public_path__ + "b54d999a7877fcd4d580c6e3bd95feb2.png";